/**
 * @flow
 * @relayHash 30bc1dae3748b105aade541250adcf3c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateMachineDowntimeStartInput = {|
  machineId: string,
  userNumber: string,
  downtimeCategoryId: string,
  startNotes?: ?string,
|};
export type UpdateMachineDowntimeStartMutationVariables = {|
  input: UpdateMachineDowntimeStartInput
|};
export type UpdateMachineDowntimeStartMutationResponse = {|
  +updateMachineDowntimeStart: {|
    +machineEdge: {|
      +cursor: string,
      +node: {|
        +id: string,
        +name: string,
        +currentDowntime: ?{|
          +id: string,
          +startNotes: ?string,
          +endNotes: ?string,
          +startAt: ?any,
          +endAt: ?any,
          +startUser: ?{|
            +id: string,
            +firstName: string,
            +lastName: string,
            +avatar: ?string,
          |},
          +endUser: ?{|
            +id: string,
            +firstName: string,
            +lastName: string,
            +avatar: ?string,
          |},
          +category: {|
            +id: string,
            +name: string,
          |},
        |},
      |},
    |}
  |}
|};
export type UpdateMachineDowntimeStartMutation = {|
  variables: UpdateMachineDowntimeStartMutationVariables,
  response: UpdateMachineDowntimeStartMutationResponse,
|};
*/


/*
mutation UpdateMachineDowntimeStartMutation(
  $input: UpdateMachineDowntimeStartInput!
) {
  updateMachineDowntimeStart(input: $input) {
    machineEdge {
      cursor
      node {
        id
        name
        currentDowntime {
          id
          startNotes
          endNotes
          startAt
          endAt
          startUser {
            id
            firstName
            lastName
            avatar
          }
          endUser {
            id
            firstName
            lastName
            avatar
          }
          category {
            id
            name
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateMachineDowntimeStartInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = [
  (v1/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "firstName",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "lastName",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "avatar",
    "args": null,
    "storageKey": null
  }
],
v4 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateMachineDowntimeStart",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateMachineDowntimeStartPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "machineEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "MachineEdge",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "cursor",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Machine",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "currentDowntime",
                "storageKey": null,
                "args": null,
                "concreteType": "MachineDowntime",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "startNotes",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "endNotes",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "startAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "endAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "startUser",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": (v3/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "endUser",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": (v3/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "category",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DowntimeCategory",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateMachineDowntimeStartMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v4/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateMachineDowntimeStartMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v4/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateMachineDowntimeStartMutation",
    "id": null,
    "text": "mutation UpdateMachineDowntimeStartMutation(\n  $input: UpdateMachineDowntimeStartInput!\n) {\n  updateMachineDowntimeStart(input: $input) {\n    machineEdge {\n      cursor\n      node {\n        id\n        name\n        currentDowntime {\n          id\n          startNotes\n          endNotes\n          startAt\n          endAt\n          startUser {\n            id\n            firstName\n            lastName\n            avatar\n          }\n          endUser {\n            id\n            firstName\n            lastName\n            avatar\n          }\n          category {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6eea90533a0563231f8f7919d12c22ea';
module.exports = node;
